// utils/customerStages.js

export const getCustomerStages = (businessType = 'insurance') => {
    const domain = businessType === 'product' ? '제품' : '보험';
    return [
        {
            id: 'prospect',
            title: '가망고객',
            subtitle: `${domain}이 필요할 것 같은 고객들`,
            color: 'bg-indigo-500',
            lightColor: 'bg-indigo-50',
            emoji: '🔍'
        },
        {
            id: 'preparation',
            title: '연락대상',
            subtitle: '첫 연락을 위해 준비하는 고객들',
            color: 'bg-blue-500',
            lightColor: 'bg-blue-50',
            emoji: '📋'
        },
        {
            id: 'appointment',
            title: '약속확정',
            subtitle: '만날 약속을 잡은 고객들',
            color: 'bg-purple-500',
            lightColor: 'bg-purple-50',
            emoji: '📅'
        },
        {
            id: 'consultation',
            title: '상담완료',
            subtitle: '상담을 마친 고객들',
            color: 'bg-cyan-500',
            lightColor: 'bg-cyan-50',
            emoji: '💬'
        },
        {
            id: 'closed',
            title: '계약고객',
            subtitle: `${domain}에 가입 완료한 고객들`,
            color: 'bg-emerald-500',
            lightColor: 'bg-emerald-50',
            emoji: '✅'
        },
        {
            id: 'rejected',
            title: '거절고객',
            subtitle: '가입을 거절한 고객들',
            color: 'bg-red-500',
            lightColor: 'bg-red-50',
            emoji: '❌'
        },
        {
            id: 'bank',
            title: '고객뱅크',
            subtitle: '지금은 단계 외, 나중에 활용할 고객',
            color: 'bg-amber-500',
            lightColor: 'bg-amber-50',
            emoji: '🗃️'
        }
    ];
};

// 기본(보험) 용어로의 하위호환 유지용 상수
export const CUSTOMER_STAGES = getCustomerStages('insurance');